import React from "react";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";

const Stepper = ({ currentStep = 3 }) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith("ar");

  const steps = [
    { id: 1, label: isArabic ? "التفاصيل" : "Details" },
    { id: 2, label: isArabic ? "العروض" : "Offers" },
    { id: 3, label: isArabic ? "البيانات الشخصية" : "Personal details" },
    { id: 4, label: isArabic ? "الدفع" : "Checkout" },
  ];


  const displaySteps = isArabic ? [...steps].reverse() : steps;

  const toArabicNumber = (num) =>
    num.toString().replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);

  return (
    <div style={{ width: "100%" }}>
      <div
        className="d-flex align-items-start mt-4"
        style={{
          width: "100%",
          flexDirection: isArabic ? "row-reverse" : "row",
        }}
      >
        {displaySteps.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isActive = step.id === currentStep;

          return (
            <div
              key={step.id}
              style={{
                flex: 1,
                textAlign: "center",
                position: "relative",
              }}
            >
              {/* LINE */}
              {index !== (isArabic ? 0 : displaySteps.length - 1) && (
                <div
                  style={{
                    position: "absolute",
                    top: "16px",
                    height: "2px",
                    width: "100%",
                    backgroundColor: isCompleted ? "#ffc107" : "#ced4da",
                    zIndex: 0,
                    left: isArabic ? "auto" : "50%",
                    right: isArabic ? "50%" : "auto",
                  }}
                />
              )}

              {/* CIRCLE */}
              <div
                style={{
                  position: "relative",
                  zIndex: 1,
                  width: 42,
                  height: 30,
                  margin: "0 auto",
                  borderRadius: "2%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  backgroundColor: isCompleted
                    ? "#000"
                    : isActive
                      ? "#ffc107"
                      : "#fff",
                  border: `1px solid ${isCompleted
                      ? "#000"
                      : isActive
                        ? "#ffc107"
                        : "#ced4da"
                    }`,
                  color: isCompleted ? "#ffc107" : "#000",
                }}
              >
                {isCompleted
                  ? "✓"
                  : isArabic
                    ? toArabicNumber(step.id)
                    : step.id}
              </div>

              {/* LABEL */}
              <div
                style={{
                  marginTop: 8,
                  fontSize: 13,
                  fontWeight : '600',
                  fontFamily: "Montserrat",
                  // whiteSpace: "nowrap",
                }}
              >
                {step.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;